const $ = window.jQuery;

let s = {
  html : $('html'),
  body : $('body'),
  push : $('.js-push'),

  pushMenuHide : 960,

  touchLengthMinX : 25,
  touchLengthMaxY : 25,

  // pushMenu         : $('.js-push__menu'),
  pushMenuSelector : '.js-push__menu',

  // pushContent : $('.js-push__content'),
  pushContentSelector : '.js-push__content',

  // menuToggle         : $('.js-menu__toggle'),
  menuToggleSelector : '.js-menu__toggle',

  // menuClose         : $('.js-menu__close'),
  menuCloseSelector : '.js-menu__close',

  // pushLevelForward         : $('.js-menu__item--has-children > a'),
  // pushLevelForwardSelector : '.js-menu__item--has-children > a',
  // pushLevelForward         : $('.js-push__menu .menu-item-has-children > a'),
  pushLevelForwardSelector : '.js-push__menu .menu-item-has-children > a',

  // pushLevelBack         : $('.js-menu__back'),
  pushLevelBackSelector : '.js-menu__back',
};

function events() {
  var touchStartX, touchStartY, touchEndX, touchEndY;

  $(window).on('load resize', function() {

    if (window.innerWidth < s.pushMenuHide && s.push.hasClass('push--active')) {
      s.html.addClass('no-scroll');
      s.body.addClass('no-scroll');
    } else {
      s.html.removeClass('no-scroll');
      s.body.removeClass('no-scroll');
    }
  });

  s.body.on('mousedown touchstart', s.pushMenuSelector, function(event) {

    touchStartX = event.originalEvent.pageX;
    touchStartY = event.originalEvent.pageY;

  })
  .on('mouseup touchend', s.pushMenuSelector, function(event) {

    touchEndX = event.originalEvent.pageX;
    touchEndY = event.originalEvent.pageY;

    // const touchUp    = touchStartY < touchEndY;
    const touchRight = touchStartX < touchEndX;
    // const touchDown  = touchStartY > touchEndY;
    // const touchLeft  = touchStartX > touchEndX;

    const touchLengthX  = Math.abs(touchStartX - touchEndX);
    const touchLengthY  = Math.abs(touchStartY - touchEndY);

    /** swipe back */
    if (touchRight && (touchLengthX > s.touchLengthMinX) && (touchLengthY < s.touchLengthMaxY)) { // swipe direction && threshold
      s.push.find('.push__level--current:not(.push__level--top)').find(s.pushLevelBackSelector).trigger('click');
    }
    // else if (touchLeft && (touchLengthX > s.touchLengthMinX) && (touchLengthY < s.touchLengthMaxY)) { // swipe direction && threshold
    // 	// do something
    // }
  });

  s.body.on('click', s.menuToggleSelector, function(event) { event.preventDefault();
    s.body.toggleClass('no-scroll');
    s.html.toggleClass('no-scroll');
    s.push.toggleClass('push--active');
    s.push.find('.push__level--top')
      .addClass('push__level--active')
      .addClass('push__level--current');

  }).on('click', s.pushLevelForwardSelector, function(event) { event.preventDefault();

    s.push.find('.push__level--current')
      .removeClass('push__level--current');

    $(this).next('.push__level')
      .addClass('push__level--active')
      .addClass('push__level--current');

  }).on('click', s.pushLevelBackSelector, function(event) { event.preventDefault();
    const $thisLevel = $(this).closest('.push__level'); // this parent

    $thisLevel
      .removeClass('push__level--active')
      .removeClass('push__level--current')
      .closest('.push__level--active') // level parent
      .addClass('push__level--current');

    /** reset scroll */
    setTimeout(function() {
      // $thisLevel.scrollTop(0);
      $thisLevel.find('.push__level__inner')
        .scrollTop(0);
    }, 400); // transition

  }).on('click', s.menuCloseSelector, function(event) { event.preventDefault();

    s.push.find('.push__level--top')
      .addClass('push__level--active')
      .addClass('push__level--current');

    setTimeout(function() {

      /** reset scroll */
      s.push
        // .find('.push__level')
        // .scrollTop(0);
        .find('.push__level__inner')
        .scrollTop(0);

      /** reset active */
      s.push
        .find('.push__level--active')
        .removeClass('push__level--active');
    }, 400); // transition
  });

  $('.post-filter select').on('change', function() {
		window.location = this.value;
	});
}

export default {
  init() {
    // JavaScript to be fired on all pages

    const navHeight = 116;
    const bannerElm = document.getElementsByClassName('banner')[0];
    const sidebarElm = document.getElementsByClassName('sidebar-fixed')[0];
    const sidebarOffset = (sidebarElm) ? $(sidebarElm).offset() : 0;
    const sidebarPinOffset = (sidebarElm) ? sidebarOffset.top - navHeight : 0;
    const footerElm = document.getElementsByClassName('footer')[0];
    const sidebarPinBottom = (sidebarElm) ? $(footerElm).offset().top - $(sidebarElm).height() - (navHeight + 30) : 0;
    window.onscroll = () => {
      let scroll = currentScroll();
      if(scroll > 145 && bannerElm.classList.contains('pinned')) {
        if(!bannerElm.classList.contains('open')) {
          bannerElm.classList.add('open');
        }
      } else if(scroll > 135) {
        bannerElm.classList.add('pinned');
      } else if(scroll < 120) {
        bannerElm.classList.remove('pinned', 'open');
      }
      if(sidebarElm) {
        if(scroll > sidebarPinOffset + 25 && sidebarElm.classList.contains('pinned')) {
          if(!sidebarElm.classList.contains('open')) {
            sidebarElm.classList.add('open');
          }
          if(scroll > sidebarPinBottom) {
            if(!sidebarElm.classList.contains('pinned-bottom')) {
              sidebarElm.classList.add('pinned-bottom');
            }
          } else {
            sidebarElm.classList.remove('pinned-bottom');
          }
        } else if(scroll > sidebarPinOffset + 15) {
          sidebarElm.classList.add('pinned');
        } else if(scroll < sidebarPinOffset) {
          sidebarElm.classList.remove('pinned', 'open');
        }
        this.updateSideNav();
      }
    }

    let currentScroll = () => {
      return window.pageYOffset || document.documentElement.scrollTop;
    }

    events();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  updateSideNav() {
    let links = $('.sidebar-fixed .page_item > a');
    let current;
    links.each((index, element) => {
      let ref = $(element).attr('href');
      if (ref.startsWith('#') && $(ref).offset().top <= $(window).scrollTop()) {
        current = element;
      }
    });
    $(current).parent().addClass('current-menu-item').siblings().removeClass('current-menu-item');
  },
};
